import {
  getSchemaText,
  initRawSchema,
  toMentionContent,
  toParagraphContent,
  toTextContent,
  RawSchema,
} from '@principle-theorem/editor';
import { IReffable } from '@principle-theorem/shared';
import {
  INotification,
  INotificationContextRenderer,
} from '@principle-theorem/notifications';
import { stafferIsOfRole } from './notification-helpers';
import {
  NotificationType,
  IAddedTaskResources,
  isTaskResource,
  MentionResourceType,
} from '@principle-theorem/principle-core/interfaces';
import { toMention } from '../../mention/mention';

export class AddedTaskContextRenderer
  implements
    INotificationContextRenderer<
      RawSchema,
      NotificationType,
      IAddedTaskResources
    >
{
  canRender(notification: INotification): boolean {
    return notification.type === String(NotificationType.AddedTask);
  }

  isResource(data: unknown): data is IAddedTaskResources {
    return isTaskResource(data);
  }

  render(data: IAddedTaskResources, currentStaffer?: IReffable): RawSchema {
    const isActor: boolean = stafferIsOfRole(currentStaffer, data.interactor);
    const isAssignee: boolean = stafferIsOfRole(
      currentStaffer,
      data.interactor
    );

    const taskMention = toMention(
      { name: getSchemaText(data.task.title), ref: data.task.ref },
      MentionResourceType.Task
    );

    if (isActor || isAssignee) {
      return initRawSchema([
        toParagraphContent([
          toTextContent(`You added task `),
          toMentionContent(taskMention),
        ]),
      ]);
    }

    if (data.interactor) {
      const interactorMention = toMention(
        data.interactor,
        MentionResourceType.Staffer
      );
      return initRawSchema([
        toParagraphContent([
          toMentionContent(interactorMention),
          toTextContent(` added task `),
          toMentionContent(taskMention),
        ]),
      ]);
    }

    return initRawSchema([
      toParagraphContent([
        toTextContent(`System added task `),
        toMentionContent(taskMention),
      ]),
    ]);
  }
}
